import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { FixedSizeList as VirtualList } from 'react-window';

import { SmallContext } from '../utils/small-context';
import Box from '../Box';
import Type from '../Typography';

import styles from './List.less';

const cx = classnames.bind(styles);
const NoOp = () => {};

const cls = (override, ...name) => name.map((x) => cx(override.replace ? override[x] : cx(override[x], x))).join(' ');

List.propTypes = {
  children: PropTypes.any,
  classes: PropTypes.shape({
    replace: PropTypes.bool,
    container: PropTypes.string,
    controls: PropTypes.string,
    header: PropTypes.string,
    list: PropTypes.string,
    row: PropTypes.string,
  }),
  title: PropTypes.string,
  item: PropTypes.array,

  rowClasses: PropTypes.func,
  rowComponent: PropTypes.any, //Any Renderable Type
  rowHeight: PropTypes.number,
  rowLabel: PropTypes.func,
  onItemClick: PropTypes.func,
  onItemDoubleClick: PropTypes.func,
};

export default function List({
  children,
  classes = {},
  height = 280,
  title,
  items = [],
  rowClasses = NoOp,
  rowLabel = (x) => '' + x,
  rowComponent,
  rowHeight = 27,
  onItemClick = NoOp,
  onItemDoubleClick = NoOp,
  ...props
}) {
  const { length: total } = items || [];

  const cxb = cls.bind(null, classes);

  const Row =
    rowComponent ||
    (({ index, className, ...props }) => (
      <Type
        {...props}
        as="div"
        role="option"
        face="subtext1"
        tabIndex="0"
        className={cxb('row', className, { odd: index % 2 })}
        onKeyDown={(e) => {
          if (!e || !/\s|Enter/.test(e.key)) return;
          e.stopPropagation();
          e.preventDefault();
          onItemClick(items[index], e);
        }}
        onClick={(e) => onItemClick(items[index], e)}
        onDoubleClick={(e) => onItemDoubleClick(items[index], e)}
      >
        {rowLabel(items[index])}
      </Type>
    ));

  return (
    <div className={cxb('container')} {...props}>
      {title && (
        <Type as="div" face="subtext1" className={cxb('header')}>
          {title}
        </Type>
      )}
      <SmallContext.Provider value={true}>
        <Box direction="column" className={cxb('controls')}>
          {children}
        </Box>
      </SmallContext.Provider>
      <VirtualList
        className={cxb('list')}
        height={height}
        width="100%"
        itemCount={total}
        itemSize={rowHeight}
        children={({ index, style }) => <Row className={rowClasses(items[index], index)} style={style} index={index} />}
      />
    </div>
  );
}
